import { JSONSchemaType } from "ajv"
import validateConstant from "../../../constant/validateConstant"
import util from "../../../ts/util"
import { TKubunBunruiPostReq, TKubunBunruiPutReq } from "./TKubun"

export const kubunBunruiRegisterPostScheme: JSONSchemaType<TKubunBunruiPostReq> =
  {
    type: "object",
    properties: {
      分類コード: {
        type: "string",
        maxLength: validateConstant.LENGTH.汎用区分コード,
        pattern: validateConstant.PATTERN.英数字のみ,
        title: "分類コード",
        errorMessage: util.stringErrorMessage("分類コード", {
          required: true,
          maxLength: validateConstant.LENGTH.汎用区分コード,
        }),
      },
      分類名: {
        type: "string",
        maxLength: validateConstant.LENGTH.一般名称,
        title: "分類名",
        nullable: false,
        errorMessage: util.stringErrorMessage("分類名", {
          required: true,
          maxLength: validateConstant.LENGTH.一般名称,
        }),
      },
      ソート番号: {
        type: "number",
        title: "ソート番号",
        nullable: false,
        errorMessage: util.stringErrorMessage("ソート番号", {
          required: true,
        }),
      },
      備考: {
        type: "string",
        maxLength: validateConstant.LENGTH.一般テキスト,
        title: "備考",
        nullable: true,
        errorMessage: util.stringErrorMessage("備考", {
          required: false,
          maxLength: validateConstant.LENGTH.一般テキスト,
        }),
      },
    },
    required: ["分類コード", "分類名", "ソート番号"],
    errorMessage: {
      required: util.JsonSchemeRequiredErrorMessages([
        "分類コード",
        "分類名",
        "ソート番号",
      ]),
    },
  }

export const kubunBunruiRegisterPutScheme: JSONSchemaType<TKubunBunruiPutReq> =
  {
    type: "object",
    properties: {
      分類コード: {
        type: "string",
        maxLength: validateConstant.LENGTH.汎用区分コード,
        pattern: validateConstant.PATTERN.英数字のみ,
        title: "分類コード",
        errorMessage: util.stringErrorMessage("分類コード", {
          required: true,
          maxLength: validateConstant.LENGTH.汎用区分コード,
        }),
      },
      分類名: {
        type: "string",
        maxLength: validateConstant.LENGTH.一般名称,
        minLength: 1,
        title: "分類名",
        errorMessage: util.stringErrorMessage("分類名", {
          required: true,
          maxLength: validateConstant.LENGTH.一般名称,
        }),
      },
      ソート番号: {
        type: "number",
        minimum: 1,
        maximum: 9999999999,
        title: "ソート番号",
        multipleOf: 1,
        errorMessage: util.stringErrorMessage("ソート番号", {
          required: true,
        }),
      },
      区分追加可能フラグ: {
        type: "number",
        minimum: 0,
        maximum: 1,
        title: "区分追加可能フラグ",
      },
      区分削除可能フラグ: {
        type: "number",
        minimum: 0,
        maximum: 1,
        title: "区分削除可能フラグ",
      },
      区分名称1変更可能フラグ: {
        type: "number",
        minimum: 0,
        maximum: 1,
        title: "区分名称1変更可能フラグ",
      },
      区分名称2変更可能フラグ: {
        type: "number",
        minimum: 0,
        maximum: 1,
        title: "区分名称2変更可能フラグ",
      },
      区分名称3変更可能フラグ: {
        type: "number",
        minimum: 0,
        maximum: 1,
        title: "区分名称3変更可能フラグ",
      },
      区分数値1変更可能フラグ: {
        type: "number",
        minimum: 0,
        maximum: 1,
        title: "区分数値1変更可能フラグ",
      },
      区分数値2変更可能フラグ: {
        type: "number",
        minimum: 0,
        maximum: 1,
        title: "区分数値2変更可能フラグ",
      },
      区分数値3変更可能フラグ: {
        type: "number",
        minimum: 0,
        maximum: 1,
        title: "区分数値3変更可能フラグ",
      },
      区分小数値1変更可能フラグ: {
        type: "number",
        minimum: 0,
        maximum: 1,
        title: "区分小数値1変更可能フラグ",
      },
      区分小数値2変更可能フラグ: {
        type: "number",
        minimum: 0,
        maximum: 1,
        title: "区分小数値2変更可能フラグ",
      },
      区分小数値3変更可能フラグ: {
        type: "number",
        minimum: 0,
        maximum: 1,
        title: "区分小数値3変更可能フラグ",
      },
      備考: {
        type: "string",
        maxLength: validateConstant.LENGTH.一般テキスト,
        title: "備考",
        nullable: true,
        errorMessage: util.stringErrorMessage("備考", {
          required: false,
          maxLength: validateConstant.LENGTH.一般テキスト,
        }),
      },
      更新日時: {
        type: "string",
        title: "更新日時",
      },
    },
    required: ["分類コード", "分類名", "ソート番号", "更新日時"],
    errorMessage: {
      required: util.JsonSchemeRequiredErrorMessages([
        "分類コード",
        "分類名",
        "ソート番号",
        "更新日時",
      ]),
    },
  }
